import styled from "styled-components";
import { useState } from "react";
import { useToast } from "../../components/Toast/ToastContext";
import { FiMail, FiLock, FiUnlock } from "react-icons/fi";
import { resetPasswordApi } from "../../services/authApi";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  ClickableIconWrapper,
  Field,
  FieldWrapper,
  IconWrapper,
  Title,
} from "../Auth/styled-component";
import DotLoader from "../../components/Loader/DotLoader";

const NewPasswordContainer = ({ onClose }: { onClose?: () => void }) => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});
  const { notify } = useToast();
  const { token } = useParams();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFieldErrors((prev) => ({ ...prev, [name]: "" }));

    if (name === "email") setEmail(value);
    if (name === "newPassword") setNewPassword(value);
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const errors: { [key: string]: string } = {};
    if (!email) errors.email = "Email is required.";
    if (!newPassword) errors.newPassword = "Password is required.";
    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setLoading(true);
    try {
      await resetPasswordApi(token!, newPassword);
      notify("Password reset successfully", { type: "success" });
      // ✅ Navigate to home page on success
      setTimeout(() => navigate("/"), 1000);
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to reset password.";
      notify(errorMessage, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Backdrop onClick={onClose}>
      <FormContainer onClick={(e) => e.stopPropagation()}>
        {/* <CloseButton onClick={onClose}>
          <AiOutlineClose />
        </CloseButton> */}
        <Title>Set New Password</Title>
        <FieldWrapper>
          <Field
            label="Email"
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
            error={!!fieldErrors.email}
            helperText={fieldErrors.email}
            InputProps={{
              endAdornment: (
                <IconWrapper>
                  <FiMail />
                </IconWrapper>
              ),
            }}
          />
        </FieldWrapper>

        <FieldWrapper>
          <Field
            label="New Password"
            name="newPassword"
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={handleChange}
            error={!!fieldErrors.newPassword}
            helperText={fieldErrors.newPassword}
            InputProps={{
              endAdornment: (
                <ClickableIconWrapper onClick={togglePasswordVisibility}>
                  {showPassword ? <FiUnlock /> : <FiLock />}
                </ClickableIconWrapper>
              ),
            }}
          />
        </FieldWrapper>
        <Button onClick={handleSubmit} disabled={loading}>
          {loading ? <DotLoader /> : "Update Password"}
        </Button>
      </FormContainer>
    </Backdrop>
  );
};

export default NewPasswordContainer;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const FormContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  padding: 30px 20px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  animation: slideIn 0.3s ease-out;
  text-align: center;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

